import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import { CiLocationOn } from "react-icons/ci";

const Footer = () => {
  const propertyTypes = ["Rooms", "Event Hall"];
  const support = [
    "Help Centre",
    "WhatsApp Chat Support",
    "Privacy Policy",
    "Contact Us",
  ];

  const payments = [
    "/assets/footer-7.svg",
    "/assets/footer-icon-1.svg",
    "/assets/footer-icon-2.svg",
    "/assets/footer-icon-3.svg",
    "/assets/footer-icon-4.svg",
    "/assets/footer-icon-5.svg",
    "/assets/foote-icon-6.svg",
  ];

  return (
    <div>
      <footer className="bg-[#001D33] md:px-20  w-full hidden  md:block">
        <div className=" py-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="space-y-5">
              <div className="flex gap-4 items-start">
                <img
                  src="/assets/sastha-logo.svg"
                  className="w-[55px]"
                  loading="lazy"
                />

                <div>
                  <p
                    className="text-[16px]  bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent"
                  >
                    HOTEL
                  </p>
                  <h2
                    className=" bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent  text-[24px] font-semibold font-calson"
                  >
                    SASTHAGRAND
                  </h2>
                </div>
              </div>

              <p className="text-[16px] leading-6 text-white font-creto font-normal w-[310px] h-[96px]">
                These premium accommodations feature spacious suites, refined
                interiors, and high-end amenities crafted to elevate every
                moment of your stay.
              </p>
            </div>

            <div className="space-y-5 ml-14">
              <h4
                className=" bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent text-[18px] font-calson font-medium"
              >
                Property Types
              </h4>

              {propertyTypes.map((item) => (
                <p
                  key={item}
                  className="text-[16px] font-creto font-normal text-white"
                >
                  {item}
                </p>
              ))}
            </div>

            <div className="space-y-5">
              <h4
                className=" bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent font-calson text-[18px] font-medium"
              >
                Get In Touch
              </h4>

              <p className="text-[16px] font-creto font-normal text-white">
                Call :{" "}
                <span className="text-white">
                  <a
                    href="tel:+917092909200"
                    className="ml-2 text-white hover:text-primary transition cursor-pointer"
                  >
                    +91 70929 09200
                  </a>
                </span>
              </p>

              <p className="text-[16px] font-creto font-normal text-white">
                Email :{" "}
                <span className="text-white">
                  <a
                    href="mailto:info@sasthagrand.com"
                    className="ml-2 text-white hover:text-primary transition cursor-pointer"
                  >
                    info@sasthagrand.com
                  </a>
                </span>
              </p>

              <p className="text-[16px] font-creto font-normal text-white">
                Address :
                <a
                  href="https://www.google.com/maps/place/Hotel+Sastha+Grand/@12.9129988,79.3211838,17z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 text-white hover:text-primary hover:underline transition duration-300 cursor-pointer"
                >
                  Chennai-bangalore highways, <br />
                  <span className="ml-0 sm:ml-[74px] block sm:inline">
                    Arcot, Ranipet - 632503.
                  </span>
                </a>
              </p>

              <div className="flex gap-3 pt-2">
                <div className="w-10 h-10 bg-white/10 rounded-md flex items-center justify-center transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                  <a
                    href="https://www.facebook.com/SasthaGrand
"
                    target="_black"
                  >
                    <FaFacebookF className="text-white" fontSize={20} />
                  </a>
                </div>
                <div className="w-10 h-10 bg-white/10 rounded-md flex items-center justify-center transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                  <a
                    href="https://www.instagram.com/sasthagrand/"
                    target="_blank"
                  >
                    <FaInstagram
                      className="text-white hover:text-[#D9B55A]"
                      fontSize={20}
                    />
                  </a>
                </div>
                <div className="relative w-9 h-9 sm:w-10 sm:h-10 rounded-md flex items-center justify-center bg-white/10 transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                  <CiLocationOn
                    className="text-white hover:text-[#D9B55A]"
                    fontSize={20}
                  />

                  <a
                    href="https://www.google.com/maps/place/Hotel+Sastha+Grand/@12.9129988,79.3211838,17z"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute inset-0"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 h-[1px] bg-white/20" />
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 w-full mt-5">
            <p className="text-[14px] font-creto text-[#F1F2F3] text-center md:text-left">
              © {new Date().getFullYear()} Hotel Sastha Grand. All rights
              reserved.
            </p>

           <a target="_black" href="https://azerotech.com/" >
             <div className="flex items-center justify-center md:justify-end">
              <img
                src="/assets/azero-footer.svg"
                alt="footer logo"
                className="h-[40px] object-contain"
              />
            </div>
           </a>
          </div>
        </div>
      </footer>
      <footer className="bg-[#001D33] w-full block md:hidden">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16">
          <div className="py-10 sm:py-12 lg:py-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
              <div className="space-y-3 sm:space-y-4">
                <div className="flex gap-3 sm:gap-4 items-start">
                  <div className="w-[40px] h-[40px] sm:w-[55px] sm:h-[55px] lg:w-[75px] lg:h-[84px]">
                    <img
                      src="/assets/sastha-logo.svg"
                      className="w-full h-full object-contain"
                      alt="logo"
                      loading="lazy"
                    />
                  </div>

                  <div className="pt-1">
                    <p
                      className="text-[12px] sm:text-[14px] lg:text-[16px] bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent"
                    >
                      HOTEL
                    </p>
                    <h2
                      className="bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent text-[16px] sm:text-[20px] lg:text-[24px] font-semibold font-calson leading-tight"
                    >
                      SASTHAGRAND
                    </h2>
                  </div>
                </div>

                <p className="text-[13px] sm:text-[14px] lg:text-[16px] leading-5 sm:leading-6 text-white font-creto font-normal w-[310px] h-[96px]">
                  These premium accommodations feature spacious suites, refined
                  interiors, and high-end amenities crafted to elevate every
                  moment of your stay.
                </p>
              </div>

              <div className="space-y-3 sm:space-y-4 lg:pl-12">
                <h4
                  className="bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent text-[14px] sm:text-[16px] lg:text-[18px] font-calson font-medium"
                >
                  Property Types
                </h4>

                <div className="space-y-2">
                  {propertyTypes.map((item) => (
                    <p
                      key={item}
                      className="text-[13px] sm:text-[14px] lg:text-[16px] font-creto font-normal text-white"
                    >
                      {item}
                    </p>
                  ))}
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                <h4
                  className="bg-[linear-gradient(90deg,#A18141_0%,#EADE9D_32.21%,#B1975A_64.42%,#EADE99_100%)]
  bg-clip-text text-transparent text-[14px] sm:text-[16px] lg:text-[18px] font-calson font-medium"
                >
                  Get In Touch
                </h4>

                <div className="space-y-2 sm:space-y-3">
                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-creto font-normal text-white">
                    Call :{" "}
                    <span className="text-white">
                      <a
                        href="tel:+917092909200"
                        className="ml-2 text-white hover:text-primary transition cursor-pointer"
                      >
                        +91 70929 09200
                      </a>
                    </span>
                  </p>

                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-creto font-normal text-white break-words">
                    Email :{" "}
                    <span className="text-white">
                      <a
                        href="mailto:info@sasthagrand.com"
                        className="ml-2 text-white hover:text-primary transition cursor-pointer"
                      >
                        info@sasthagrand.com
                      </a>
                    </span>
                  </p>

                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-creto font-normal text-white flex flex-col sm:flex-row sm:items-start">
                    <span className="min-w-[70px]">Address :</span>

                    <a
                      href="https://www.google.com/maps/place/Hotel+Sastha+Grand/@12.9129988,79.3211838,17z"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="sm:ml-2 hover:text-primary hover:underline transition duration-300 break-words"
                    >
                      Chennai-bangalore highways, Arcot, Ranipet - 632503.
                    </a>
                  </p>
                </div>

                <div className="flex flex-wrap gap-3 pt-2">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 rounded-md flex items-center justify-center transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                    <a
                      href="https://www.facebook.com/SasthaGrand"
                      target="_black"
                    >
                      <FaFacebookF className="text-white" />
                    </a>
                  </div>
                  <div className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 rounded-md flex items-center justify-center transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                    <a
                      href="https://www.instagram.com/sasthagrand/"
                      target="_black"
                    >
                      <FaInstagram className="text-white" />
                    </a>
                  </div>
                  <div className="relative w-9 h-9 sm:w-10 sm:h-10 rounded-md flex items-center justify-center bg-white/10 transition-all duration-300 hover:bg-[#D9B55A] hover:scale-105 cursor-pointer">
                    <CiLocationOn
                      className="text-white hover:text-[#D9B55A]"
                      fontSize={20}
                    />

                    <a
                      href="https://www.google.com/maps/place/Hotel+Sastha+Grand/@12.9129988,79.3211838,17z"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute inset-0"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 sm:mt-10 lg:mt-12 h-[1px] bg-white/20" />

           <div className="flex flex-col md:flex-row justify-between items-center gap-6 w-full mt-5">
            <p className="text-[14px] font-creto text-[#F1F2F3] text-center md:text-left">
              © {new Date().getFullYear()} Hotel Sastha Grand. All rights
              reserved.
            </p>

           <a target="_black" href="https://azerotech.com/" >
             <div className="flex items-center justify-center md:justify-end">
              <img
                src="/assets/azero-footer.svg"
                alt="footer logo"
                className="h-[40px] object-contain"
              />
            </div>
           </a>
          </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
